import React, { useState } from 'react';
import { useT } from '../context/AppContext';
import './SecurityModals.css';

export const ChangePasswordModal = ({ isOpen, onClose }) => {
  const tr = useT();
  const [formData, setFormData] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.newPassword !== formData.confirmPassword) { alert(tr('erreur')); return; }
    alert(tr('succes'));
    onClose();
  };

  if (!isOpen) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content-security" onClick={e => e.stopPropagation()}>
        <div className="modal-header-security">
          <h2><i className="fas fa-key"></i> {tr('changer_mdp')}</h2>
          <button className="modal-close" onClick={onClose}><i className="fas fa-times"></i></button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group-modal">
            <label>{tr('mdp_actuel')}</label>
            <input type="password" required value={formData.currentPassword} onChange={e => setFormData({...formData, currentPassword: e.target.value})} />
          </div>
          <div className="form-group-modal">
            <label>{tr('nouveau_mdp')}</label>
            <input type="password" required value={formData.newPassword} onChange={e => setFormData({...formData, newPassword: e.target.value})} />
          </div>
          <div className="form-group-modal">
            <label>{tr('confirmer_mdp')}</label>
            <input type="password" required value={formData.confirmPassword} onChange={e => setFormData({...formData, confirmPassword: e.target.value})} />
          </div>
          <div className="modal-actions-security">
            <button type="button" className="btn-modal-cancel" onClick={onClose}>{tr('annuler')}</button>
            <button type="submit" className="btn-modal-confirm">
              <i className="fas fa-check"></i> {tr('changer_mdp')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export const Enable2FAModal = ({ isOpen, onClose }) => {
  const tr = useT();
  const [step, setStep] = useState(1);
  const [code, setCode] = useState('');

  const handleEnable = () => {
    if (code.length === 6) { alert(tr('succes')); onClose(); }
    else alert(tr('erreur'));
  };

  if (!isOpen) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content-security" onClick={e => e.stopPropagation()}>
        <div className="modal-header-security">
          <h2><i className="fas fa-mobile-alt"></i> {tr('activer_2fa')}</h2>
          <button className="modal-close" onClick={onClose}><i className="fas fa-times"></i></button>
        </div>
        <div className="twofa-content">
          {step === 1 && (
            <>
              <div className="qr-code-section">
                <div className="qr-code-placeholder"><i className="fas fa-qrcode"></i><p>QR Code</p></div>
              </div>
              <button className="btn-modal-confirm full-width" onClick={() => setStep(2)}>
                J'ai scanné le QR code
              </button>
            </>
          )}
          {step === 2 && (
            <>
              <div className="form-group-modal">
                <label>Code</label>
                <input type="text" maxLength="6" value={code} onChange={e => setCode(e.target.value.replace(/\D/g, ''))} placeholder="000000" className="code-input" />
              </div>
              <div className="modal-actions-security">
                <button className="btn-modal-cancel" onClick={() => setStep(1)}>{tr('annuler')}</button>
                <button className="btn-modal-confirm" onClick={handleEnable}>
                  <i className="fas fa-check"></i> {tr('activer_2fa')}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export const LoginHistoryModal = ({ isOpen, onClose }) => {
  const tr = useT();
  const loginHistory = [
    { date: '2024-03-10 15:30', location: 'Paris, France', device: 'Chrome / Windows', ip: '192.168.1.1', status: 'success' },
    { date: '2024-03-09 09:15', location: 'Paris, France', device: 'Mobile Safari',    ip: '192.168.1.2', status: 'success' },
    { date: '2024-03-08 18:45', location: 'Lyon, France',  device: 'Firefox / MacOS',  ip: '192.168.1.3', status: 'success' },
    { date: '2024-03-07 12:00', location: 'Lomé, Togo',    device: 'Chrome / Android', ip: '192.168.1.4', status: 'failed'  },
  ];

  if (!isOpen) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content-security large" onClick={e => e.stopPropagation()}>
        <div className="modal-header-security">
          <h2><i className="fas fa-history"></i> {tr('historique_connexion')}</h2>
          <button className="modal-close" onClick={onClose}><i className="fas fa-times"></i></button>
        </div>
        <div className="login-history-list">
          {loginHistory.map((login, i) => (
            <div key={i} className="login-history-item">
              <div className="login-status">
                <i className={`fas ${login.status === 'success' ? 'fa-check-circle success' : 'fa-times-circle failed'}`}></i>
              </div>
              <div className="login-details">
                <div className="login-main">
                  <span className="login-device">{login.device}</span>
                  <span className="login-date">{login.date}</span>
                </div>
                <div className="login-sub">
                  <span><i className="fas fa-map-marker-alt"></i> {login.location}</span>
                  <span><i className="fas fa-network-wired"></i> {login.ip}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="modal-actions-security">
          <button className="btn-modal-confirm full-width" onClick={onClose}>{tr('fermer')}</button>
        </div>
      </div>
    </div>
  );
};